import { h, FunctionComponent } from 'preact';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import CurrencyText from '~src/domains/common/components/CurrencyText';
import InfoGroup from '~src/domains/common/components/InfoGroup';
import {
  loanOfferSelectionSelector,
  loanOffersSelector,
  localeSelector,
} from '~src/domains/common/state/commonSelectors';

import * as styles from '~src/styles/domains/start/StartPage.module.scss';
import StartFromPricing from './StartFromPricing';

const StartOnboardInfo: FunctionComponent = () => {
  const { t } = useTranslation();

  const loanOfferSelection = useSelector(loanOfferSelectionSelector);
  const loanOffers = useSelector(loanOffersSelector);
  const offer = loanOffers.find(offer => offer.offer_id === loanOfferSelection);
  const locale = useSelector(localeSelector);

  return (
    <div className={styles['start-onboard-spend-readonly']}>
      {offer && (
        <>
          <InfoGroup
            header={t('start:read-only-labels.loan-amount')}
            value={
              <CurrencyText
                value={offer.order_amount}
                locale={locale}
                superscript={true}
              />
            }
          />
          <StartFromPricing offer={offer} locale={locale} />
        </>
      )}
    </div>
  );
};

export default StartOnboardInfo;
